import en from './en.json'//英语语言包
import zhCN from './zh-CN.json' // 中文简体
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
 
 
const lang = window.localStorage.getItem('language') || 'en';//获取缓存中的语言
// VueI18n构造函数所需要的配置
const i18nConfig = {
	fallbackLocale: 'zh-CN', // 预设的语言环境
  locale: lang,//当前语言
	legacy: false, //如果要支持compositionAPI，此项必须设置为false;
	globalInjection: true, // 全局注册$t方法
	// 所需要用的语言包
	messages:{
		'zh-CN': zhCN,
		en,
	}
}
const i18n = new VueI18n(i18nConfig)
export default i18n